'use client';

import { useCallback, useEffect } from 'react';
import { useGeminiVoice } from '@hooks/voice/useGeminiVoice';
import type { GeminiVoiceOptions, GeminiVoiceSession } from '@hooks/voice/useGeminiVoice';
import GeminiVoiceCard from '@components/features/voice/GeminiVoiceCard';

interface GeminiVoiceWidgetProps extends GeminiVoiceOptions {
  autoStart?: boolean;
  onClose?: () => void;
  session?: GeminiVoiceSession;
}

export default function GeminiVoiceWidget({
  agentName,
  promptParts,
  firstMessage,
  maxRetries,
  session,
  fetchSession,
  autoStart = true,
  onClose,
}: GeminiVoiceWidgetProps) {
  const { status, error, start, stop } = useGeminiVoice({
    agentName,
    promptParts,
    firstMessage,
    maxRetries,
    session,
    fetchSession,
  });

  useEffect(() => {
    if (autoStart) {
      void start();
    }
    return () => { stop(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = useCallback(() => {
    stop();
    onClose?.();
  }, [stop, onClose]);

  return <GeminiVoiceCard status={status} error={error} onClose={handleClose} />;
}
